/**
 * ownerRouteMap.js — Carte page ↔ URL du shell propriétaire (Sprint routeur).
 *
 * PAGE_TO_PATH / PATH_TO_PAGE : toutes les pages routées du shell owner. L'URL
 * fait foi (rendu via <Routes> dans OwnerRoutes). Lot 3 : les pages LÉGALES y
 * entrent (/legal/* + /support) — la coexistence routeur/`currentPage` est donc
 * close côté owner (plus de NON_ROUTED_PAGES ; le retrait de l'état `currentPage`
 * lui-même reste pour le Lot 5).
 *
 * Légales : rendu CONDITIONNEL à l'auth (D-ROUTER-3, iso strict) — authentifié →
 * in-shell (OwnerRoutes, ces routes) ; déconnecté → page NUE (court-circuit public
 * d'App.jsx via routing/publicLegalRoutes). Même URL, rendu distinct selon l'auth.
 */
import { matchPath } from 'react-router-dom';
import { PAGES } from '../constants/pages';

export const PAGE_TO_PATH = Object.freeze({
  [PAGES.LIST]:      '/sessions',
  [PAGES.HORSES]:    '/horses',
  [PAGES.NEW_HORSE]: '/horses/new',
  [PAGES.PROFILE]:   '/account',   // settings/UserProfile — ≠ /profil (profile/ProfilePage)
  [PAGES.ADMIN]:     '/admin',
  [PAGES.FEEDBACK]:  '/feedback',
  [PAGES.FAQ]:       '/faq',
  [PAGES.NOTICE]:    '/notice',
  [PAGES.UPLOAD]:    '/import',
  // Légales (Lot 3) — in-shell quand authentifié. CONTENU FR inchangé (track 1.11).
  [PAGES.MENTIONS]:  '/legal/mentions',
  [PAGES.CGU]:       '/legal/cgu',
  [PAGES.PRIVACY]:   '/legal/privacy',
  [PAGES.COOKIES]:   '/legal/cookies',
  [PAGES.MODERATION]:'/legal/moderation',
  [PAGES.CGV]:       '/legal/cgv',   // pas de route PUBLIQUE (resté authentifié-only, iso)
  [PAGES.SUPPORT]:   '/support',
});

export const PATH_TO_PAGE = Object.freeze(
  Object.fromEntries(Object.entries(PAGE_TO_PATH).map(([page, path]) => [path, page]))
);

/**
 * resolveActivePage — onglet AppNav actif pour l'URL courante (l'URL fait foi).
 *
 * ISO-COMPORTEMENT du surlignage : chemins connus (incl. /legal/* + /support) →
 * PATH_TO_PAGE (les légales renvoient leur PAGE, qui n'est pas un onglet → rien
 * surligné, comme avant) ; pages paramétrées → la PAGE legacy correspondante
 * (/sessions/:id → LIST surligne « Sessions » ; detail/health/live/compare →
 * aucun onglet) ; défaut LIST. (Lot 5 : param `currentPage` mort retiré.)
 */
export function resolveActivePage(pathname) {
  if (PATH_TO_PAGE[pathname])            return PATH_TO_PAGE[pathname];
  // Légale EN authentifiée (ex. /en/legal/cgv, i18n 1.11) → même onglet que sa
  // version FR (aucun, les légales ne sont pas un onglet). Strip du préfixe /en.
  if (pathname.startsWith('/en/legal/') && PATH_TO_PAGE[pathname.slice(3)]) return PATH_TO_PAGE[pathname.slice(3)];
  if (matchPath('/horses/:id/health', pathname)) return PAGES.HEALTH;
  if (matchPath('/horses/:id/live', pathname))   return PAGES.LIVE;
  if (matchPath('/horses/:id', pathname))        return PAGES.DETAIL;
  if (matchPath('/sessions/:id', pathname))       return PAGES.LIST;
  if (pathname === '/compare')                    return PAGES.COMPARE;
  return PAGES.LIST;
}
